import { Injectable, Injector } from '@angular/core';

import { Notifications_FrontendFlowService } from './Notifications.frontend.flow.index';
import { FootprintApiManager_FrontendFlowService } from './FootprintApiManager.frontend.flow.index';


import { $frontendTypes } from './app.frontend.types'

@Injectable({ providedIn: 'root' })
export class app_FrontendFlowService {

  constructor(
    public Notifications: Notifications_FrontendFlowService,
    public FootprintApiManager: FootprintApiManager_FrontendFlowService,
    private injector: Injector
  ) {
  }

  public app: app_FrontendFlowService = this;

  // injecting lazily in order to avoid circular dependencies
}
